import { getProvider, getWeb3 } from ".";
import config from "../../config/config";

import MafiaBasicCrimeAbi from "../../abis/MafiaBasicCrime.json";

export const getMafiaContract = (provider = false) => {
  const web3 = provider ? getProvider() : getWeb3();
  const contractAddress = config.basicCrimeAddress;
  const MafiaBasicCrimeContract = new web3.eth.Contract(
    MafiaBasicCrimeAbi,
    contractAddress
  );
  return MafiaBasicCrimeContract;
};

export const makeCrime = async (crimeType: number, account: string) => {
  const MafiaBasicCrimeContract = getMafiaContract(true);

  try {
    const result = await MafiaBasicCrimeContract.methods
      .makeCrime(crimeType)
      .send({ from: account });
    return result;
  } catch (error) {
    console.error("Error executing crime:", error);
    throw error;
  }
};

export const getSuccessRate = async (rankLevel: number, crimeType: number) => {
  const MafiaBasicCrimeContract = getMafiaContract();
  const successRate = await MafiaBasicCrimeContract.methods
    .getSuccessRate(rankLevel, crimeType)
    .call();
  return successRate;
};

export const getNextCrimeTime = async (account: string) => {
  const MafiaBasicCrimeContract = getMafiaContract();
  const nextCrimeTime: number = await MafiaBasicCrimeContract.methods
    .nextCrimeTime(account)
    .call();
  return Number(nextCrimeTime);
};
